/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAngleLeft: {
  name: 'angle-left';
  data: string;
} = {
  name: 'angle-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.707 5.293a1 1 0 0 1 0 1.414L10.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L9 13.414a2 2 0 0 1 0-2.828l5.293-5.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
